

export const SET_ALL_USERS = 'boilerplate/UserManagement/SET_ALL_USERS';
export const LOADER_STATUS = 'boilerplate/UserManagement/LOADER_STATUS';
export const SET_CREATE_USER_MODAL = 'boilerplate/UserManagement/SET_CREATE_USER_MODAL';
export const GET_ALL_COMPANIES = 'boilerplate/UserManagement/GET_ALL_COMPANIES';
export const GET_ALL_GROUPS = 'boilerplate/UserManagement/GET_ALL_GROUPS';
export const SET_Edit_USER_MODAL = 'boilerplate/UserManagement/SET_Edit_USER_MODAL';
export const SET_USER_LAST_ACTIVITY = 'boilerplate/UserManagement/SET_USER_LAST_ACTIVITY';

export const ON_NOTIFY = 'boilerplate/UserManagement/ON_NOTIFY'
export const TOTAL_RECORD = 'boilerplate/UserManagement/TOTAL_RECORD'